import * as React from 'react';
var CreateButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (React.createElement("div", { className: "create-container", onClick: onClick },
        React.createElement("label", { className: "create" }, children)));
};
export default CreateButton;



//////////////////
// WEBPACK FOOTER
// ./src/components/CreateButton.tsx
// module id = 298
// module chunks = 0